module.exports = __webpack_public_path__ + "static/bg5.9bcfd19e.png";